module.exports = __webpack_public_path__ + "static/media/logo-green.9165a6eb.svg";